






import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';
library.add(faSpinner);

import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import Setting from './Setting.vue';

@Component({
  name: 'settings',
  components: {
    Setting
  }
})
export default class Settings extends Vue {
  @State(s => s.AppMod.settings)
  settings!: Setting[];

  @Prop({ default: 'general' })
  private group!: string;
}
